import { Box } from '@mui/material';
import { StaticAddon } from 'components/common/static-addon/StaticAddon';
import useBundleTranslation from 'i18n';
import ReactSelect from 'components/common/react-select/ReactSelect';
import { FormComponentValue } from 'components/common/form/layout/control';
import { ReportLensReport } from './types';

const ALL_REPORTS_VALUE = '';

interface ReportLensSelectProps {
    reports: ReportLensReport[];
    selectedReportElementId: number | null;
    onChange: (elementId: number | null) => void;
    // Flows with the host's header instead of pinning itself to the panel header's top-right corner.
    inline?: boolean;
    disabled?: boolean;
    // Fills its flex slot and shows the label as a leading addon.
    fullWidth?: boolean;
}

export default function ReportLensSelect({
    reports,
    selectedReportElementId,
    onChange,
    inline = false,
    disabled = false,
    fullWidth = false,
}: ReportLensSelectProps) {
    const { t } = useBundleTranslation('components/common/knowledge-graph/panel');
    const value = selectedReportElementId != null ? String(selectedReportElementId) : ALL_REPORTS_VALUE;

    const options: FormComponentValue[] = [
        { label: t('report_lens_all'), value: ALL_REPORTS_VALUE },
        ...reports.map((r) => ({ label: r.name, value: String(r.element_id) })),
    ];

    return (
        <Box
            sx={
                fullWidth
                    ? { display: 'flex', flexWrap: 'nowrap', flex: 1, minWidth: 0 }
                    : inline
                      ? { minWidth: 200, maxWidth: 263, flexShrink: 0 }
                      : { position: 'absolute', top: 8, right: 16, minWidth: 200 }
            }
        >
            {fullWidth && <StaticAddon>{t('report_lens_label')}</StaticAddon>}
            <Box sx={fullWidth ? { flex: 1, minWidth: 0 } : undefined}>
                <ReactSelect
                    name="kg_report_lens"
                    dataTest="kg_report_lens_select"
                    placeholder={t('report_lens_label')}
                    data={options}
                    value={value}
                    disabled={disabled}
                    update={(raw: string) => onChange(ALL_REPORTS_VALUE === raw ? null : Number(raw))}
                />
            </Box>
        </Box>
    );
}
